<template lang="pug">
#betDetails.tab-pane.nopad.fade.show.active
  #preloader(v-if="loadingResult")
    #loader
  .table-responsive.statement-web
    template(v-if="this.category === 'REBATE'")
      table.table-history
        thead
          tr
            th ID
            th {{$t('ui.platform')}} 
            th {{$t('ui.winlose')}} 
            th {{$t('ui.date')}}
        template(v-if="betDetails.length > 0")
          tbody
            tr(v-for="data in betDetails")
              td {{data.result_id}}
              td {{data.game_name}}
              td {{data.winlose}}
              td {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
        template(v-else)
          tbody
            tr
              td(colspan="4") {{ $t('ui.no_record') }}
      .pagenumber.my-2
        paginate(
          v-if="!noHistory"
          :click-handler="changePage"
          :pageCount="pageCount"
          :page-range="4"
          :margin-pages="3"
          :prev-text="''"
          :next-text="''"
          :container-class="'p-0 m-0'"
          :page-class="'round'"
          :page-link-class="''"
          :prev-class="'round prev'"
          :next-class="'round next'"
          :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
          :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
    template(v-else)
      table.table-history
        thead
          tr
            th ID
            th {{$t('ui.game_name')}} 
            th {{$t('ui.winlose')}} 
            th {{$t('ui.date')}}
        template(v-if="betDetails.length > 0")
          tbody
            tr(v-for="data in betDetails")
              td(v-if="data.game_type!=='Referral Rebate'")
                a.text-primary(href="javascript:void(0)" @click="getBetDetails(data.result_id, data.provider_code)") {{data.result_id}}
              td(v-else) {{data.result_id}}
              td {{data.game_name}}
              td {{data.winlose}}
              td {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
        template(v-else)
          tbody
            tr
              td(colspan="4") {{ $t('ui.no_record') }}
      .pagenumber.my-2
        paginate(
          v-if="!noHistory"
          :click-handler="changePage"
          :pageCount="pageCount"
          :page-range="4"
          :margin-pages="3"
          :prev-text="''"
          :next-text="''"
          :container-class="'p-0 m-0'"
          :page-class="'round'"
          :page-link-class="''"
          :prev-class="'round prev'"
          :next-class="'round next'"
          :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
          :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
  .statement-mob
    template(v-if="this.category === 'REBATE'")
      template(v-if="betDetails.length > 0")
        .statement-single(v-for="data in betDetails")  
          .statement-single-content  
            .statement-date {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
            .statement-detail
              .statement-detail-left ID
              .statement-detail-right
                a.no-deco {{data.result_id}}
            .statement-detail
              .statement-detail-left {{ $t('ui.description') }}
              .statement-detail-right {{data.game_name}}
            .statement-detail
              .statement-detail-left {{ $t('ui.winlose') }}
              .statement-detail-right {{data.winlose}}
        .pagenumber.my-2
          paginate(
            v-if="!noHistory"
            :click-handler="changePage"
            :pageCount="pageCount"
            :page-range="4"
            :margin-pages="3"
            :prev-text="''"
            :next-text="''"
            :container-class="'p-0 m-0'"
            :page-class="'round'"
            :page-link-class="''"
            :prev-class="'round prev'"
            :next-class="'round next'"
            :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
            :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
      template(v-else)
        .text-center.py-2 {{ $t('ui.no_record') }}
    template(v-else)
      template(v-if="betDetails.length > 0")
        .statement-single(v-for="data in betDetails")  
          .statement-single-content  
            .statement-date {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
            .statement-detail
              .statement-detail-left ID
              .statement-detail-right
                a.text-primary(v-if="data.game_type!=='Referral Rebate'" href="javascript:void(0)" @click="getBetDetails(data.result_id, data.provider_code)") {{data.result_id}}
                  i.fa-solid.fa-circle-chevron-right.ms-1
                a.no-deco(v-else) {{data.result_id}}
            .statement-detail
              .statement-detail-left {{ $t('ui.game_name') }}
              .statement-detail-right {{data.game_name}}
            .statement-detail
              .statement-detail-left {{ $t('ui.winlose') }}
              .statement-detail-right {{data.winlose}}
        .pagenumber.my-2
          paginate(
            v-if="!noHistory"
            :click-handler="changePage"
            :pageCount="pageCount"
            :page-range="4"
            :margin-pages="3"
            :prev-text="''"
            :next-text="''"
            :container-class="'p-0 m-0'"
            :page-class="'round'"
            :page-link-class="''"
            :prev-class="'round prev'"
            :next-class="'round next'"
            :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
            :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
      template(v-else)
        .text-center.py-2 {{ $t('ui.no_record') }}
</template>
<script>
import config from '@/config'
import Paginate from "vuejs-paginate";
export default {
  components: {
    Paginate
  },
  props:{   
    category: {
      type: String,
    },
  },
  data(){
    return{
      // noHistory: true
      working_date: "",
      currentPage: 1,
      feedback: {
        status: "",
        success: ""
      },
      pageSize: 10,
      path: "",
      loadingResult:false,
    }
  },
  computed:{
    currencyCode() {
      return this.$store.getters.currencyCode;
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
    getLanguage() {
      return this.$store.getters.language || "my"
    },
    getPlatformSelected(){
      return this.$store.getters.platformSelected
    },
    betDetails(){
      if(this.getPlatformSelected === 'LIVECASINO'){
        return this.$store.getters.livecasinoResult.data;
      }else if(this.getPlatformSelected === 'SLOTS'){
        return this.$store.getters.slotResult.data;
      }else if(this.getPlatformSelected === 'REBATE'){
        return this.$store.getters.rebateResult.data;
      }else if(this.getPlatformSelected === 'SPORTSBOOK'){
        return this.$store.getters.sbResult.data;
      }else{
        return ""
      }
    },
    workingDate() {
      if(this.getPlatformSelected === 'LIVECASINO'){
        return this.$store.getters.livecasinoResult.working_date;
      }else if(this.getPlatformSelected === 'SLOTS'){
        return this.$store.getters.slotResult.working_date;
      }else if(this.getPlatformSelected === 'REBATE'){
        return this.$store.getters.rebateResult.working_date;
      }else if(this.getPlatformSelected === 'SPORTSBOOK'){
        return this.$store.getters.sbResult.working_date;
      }else{
        return ""
      }
    },
    noHistory(){
      if(this.betDetails.length > 0){
        return false
      }else{
        return true
      }
    },
    pageCount() {
      if (!this.noHistory) {
        var page = this.betDetails[0].totalrows / 10;
        if (page % 1 != 0) {
          page = page + 1;
        }
        return Math.floor(page);
      } else {
        return 0;
      }
    }
  },
  methods:{
    getColor(value) {
      if (value > 0) {
        return "text-success";
      } else if (value < 0) {
        return "text-danger";
      } else {
        return "";
      }
    },
    getText(value) {
      if (value > 0) {
        return "ui.win";
      } else if (value < 0) {
        return "ui.lose";
      } else {
        return "ui.tie";
      }
    },
    changePage(e) {
      this.currentPage = e;
      this.getMemberGameResult(this.getPlatformSelected, this.workingDate, this.pageSize, e);
    },
    getMemberGameResult(option, workingDate, page_size, page_number){
      switch(option){
        case "LIVECASINO":
          this.url = config.getGameResultLivecasino()
          this.path = "user/sLivecasinoResult"
          this.category = "LIVECASINO"
          break;

        case "SLOTS":
          this.url = config.getGameResultSlot()
          this.path = "user/sSlotResult"
          this.category = "SLOTS"
          break;

        case "REBATE":
          this.url = config.getGameResultRebate()
          this.path = "user/sRebateResult"
          this.category = "REBATE"
          break;

        case "SPORTSBOOK":
          this.url = config.getGameResultSb()
          this.path = "user/sSbResult"
          this.category = "SPORTSBOOK"
          break;
        default:
          break;
      }
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let url = this.url
        let working_date = workingDate
        let category = this.category
        this.$store
          .dispatch("user/getMemberGameResult", { account_id, working_date, page_size, page_number, auth_token, url, category })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch(this.path, { data: response.data, size: 10, index: 1, working_date: working_date })
                .then(() => {
                  // $("#modal-bet-history").modal("hide")
                  // $("#modal-details").modal("show")
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    getBetDetails(id, provider){
      this.loadingResult = true
      switch(provider){
        case "SPADE":
          this.path = "user/getSpadeResult"
          break;
        case "PP-S":
          this.path = "user/getPpsResult"
          break;
        case "JK":
          this.path = "user/getJokerResult"
          break;
        case "EPIC2":
          this.path = "user/getEpic2Result"
          break;
        case "LIVE22":
          this.path = "user/getLive22Result"
          break;
        case "HBNR":
          this.path = "user/getHbResult"
          break;
        case "MEGAH5":
          this.path = "user/getMegaH5Result"
          break;
        case "CQ9":
          this.path = "user/getCq9Result"
          break;
        case "JILI":
          this.path = "user/getJiliResult"
          break;
        case "FC":
        case "JDB":
        case "JDB-GTF":
        case "MG1":
        case "SPNX":
        case "BG":
        case "YBNGO":
        case "HSG":
        case "RG":
        case "EVOP":
        case "PNG":
        case "EVONTT":
        case "EVORT":
        case "EVOBTG":
        case "EVONLC":
        case "BNG":
        case "AP":
        case "HSD":
        case "QM":
        case "EVOLIVE":
        case "WIFT":
        case "YB":
          this.path = "user/getOneapiResult"
          break;
        default:
          this.path = ""
      }
      var vm = this
      if(provider === "EPIC"){
        vm.loadingResult = false
        setTimeout(() => {
          window.open(
            config.epicResultUrl + id,
            "info",
            "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640"
          );
        }) 
      }else{
        let player_id = this.accountID
        let ticket_id = id
        let lang_code = this.getLanguage
        this.$store
          .dispatch(this.path, { player_id, ticket_id, lang_code })
          .then(response => {
            if (response.success == true) {
              setTimeout(() => {
                vm.loadingResult = false
                window.open(
                  response.data,
                  "info",
                  "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640"
                );
              }) 
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
              this.loadingResult = false
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.loadingResult = false
          });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.l-width{
  max-width: 175px;
}
</style>